import { render, staticRenderFns } from "./HeaderBottomUserNotification.vue?vue&type=template&id=2293977a&scoped=true&"
import script from "./HeaderBottomUserNotification.vue?vue&type=script&lang=ts&"
export * from "./HeaderBottomUserNotification.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBottomUserNotification.vue?vue&type=style&index=0&id=2293977a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293977a",
  null
  
)

export default component.exports